// src/Dashboard/pages/user/CalendarEvents/components/CalendarEventSkeleton.jsx

import React from "react";

export default function CalendarEventSkeleton() {
  return (
    <article className="overflow-hidden rounded-[26px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-950">
      <div className="h-56 animate-pulse bg-slate-200 dark:bg-slate-800" />

      <div className="space-y-3 p-4">
        <div className="flex gap-2">
          <div className="h-6 w-20 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
          <div className="h-6 w-28 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
        </div>

        <div className="h-5 w-2/3 animate-pulse rounded bg-slate-200 dark:bg-slate-800" />
        <div className="h-3 w-full animate-pulse rounded bg-slate-200 dark:bg-slate-800" />
        <div className="h-3 w-5/6 animate-pulse rounded bg-slate-200 dark:bg-slate-800" />
        <div className="h-3 w-3/5 animate-pulse rounded bg-slate-200 dark:bg-slate-800" />

        <div className="h-12 w-full animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800" />
      </div>
    </article>
  );
}